<template>
  <div id="app">
    <router-view/>
    <notification-prompt v-if="isAuthenticated" />
  </div>
</template>

<script>

import NotificationPrompt from '@/components/shared/NotificationsPrompt';
import { mapGetters } from 'vuex';
import { ACCESS_TOKEN, NOTIFICATIONS, USER } from '@/utils/const';
import firebase from 'firebase/app';
import 'firebase/analytics';
import helpers from '@/utils/helpers';
import { version } from '../package.json';

export default {
  name: 'App',
  components: { NotificationPrompt },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
  },
  metaInfo: {
    title: 'Pacis Insurance',
    titleTemplate: 'Customer Portal | %s',
    changed(metaInfo) {
      firebase.analytics().setCurrentScreen(metaInfo.title);
      firebase.analytics().logEvent('page_view');
      firebase.analytics().logEvent('screen_view', {
        app_name: helpers.isPWA() ? 'pwa' : 'web',
        screen_name: metaInfo.title,
        app_version: version,
      });
    },
  },
  beforeCreate() {
    if (this.$store.getters['auth/isAuthenticated'] && (this.$cookies.get(USER) === null || this.$cookies.get(ACCESS_TOKEN) === null)) {
      this.$store.dispatch('auth/signOut').then(() => {
        this.$store.commit('setClient', []);
        localStorage.removeItem(NOTIFICATIONS);
        this.$router.push({ name: 'SignIn' });
      });
    }
  },
  created() {
    window.addEventListener('offline', () => {
      this.$toast.error('Seems you\'re offline!', 'No Internet');
    });
    window.addEventListener('online', () => {
      this.$toast.success('You\'re back online', 'Online');
      if (window.location.pathname === '/no-internet') {
        this.$router.go(-1);
      }
    });
  },
};
</script>
